import { EMoneyConditionType } from "../../Enum/EMoneyConditionType"
import { AwardEntity } from "../Awards/AwardEntity"
import { CouponEntity } from "../Coupon/CouponEntity"
import { ExtraServiceEntity } from "../ExtraService/ExtraServiceEntity"
import { OrderDrink } from "../Order/OrderDrink"
import { OrderMeal } from "../Order/OrderMeal"
import { ApplyAwardDiscounts } from "./ApplyAwardDiscounts"

export class CalculateTotalOrder {
  valueBaseMeals: number = 0

  valueBaseDrinks: number = 0

  valueBaseSun: number = 0

  valueBaseSunWithDiscout: number = 0

  valueBaseExtraServices: number = 0

  valueTotalDiscount: number = 0

  valuefinal: number = 0

  valuefinalWithoutAwards: number = 0

  valueAddtionals: number = 0

  valueTotalAwards: number = 0

  valueTotalCupons: number = 0

  clear() {
    this.valuefinalWithoutAwards = 0

    this.valueTotalCupons = 0

    this.valueTotalAwards = 0

    this.valueBaseMeals = 0

    this.valueBaseDrinks = 0

    this.valueBaseSun = 0

    this.valueBaseSunWithDiscout = 0

    this.valueBaseExtraServices = 0

    this.valueTotalDiscount = 0

    this.valuefinal = 0

    this.valueAddtionals = 0
  }

  calculate(
    meals: OrderMeal[],
    drinks: OrderDrink[],
    service: ExtraServiceEntity[],
    awards?: AwardEntity[],
    couponEntity?: CouponEntity,
  ) {
    this.clear()

    meals.forEach((ss) => {
      this.valueBaseMeals += ss.calculatePromotions!.valueBase

      this.valueTotalDiscount += ss.calculatePromotions!.valueDiscount

      this.valueBaseSun += ss.calculatePromotions!.valueBase + ss.calculatePromotions!.valueAddtionals

      this.valueBaseSunWithDiscout += ss.calculatePromotions!.valueFinal

      this.valueAddtionals += ss.calculatePromotions!.valueAddtionals
    })

    drinks.forEach((ss) => {
      this.valueBaseDrinks += ss.calculatePromotions!.valueBase

      this.valueTotalDiscount += ss.calculatePromotions!.valueDiscount

      this.valueBaseSun += ss.calculatePromotions!.valueBase + ss.calculatePromotions!.valueAddtionals

      this.valueBaseSunWithDiscout += ss.calculatePromotions!.valueFinal

      this.valueAddtionals += ss.calculatePromotions!.valueAddtionals
    })

    const couponDiscount = couponEntity?.getDiscountValue(this.valueBaseSunWithDiscout) ?? 0

    this.valueTotalCupons = Math.min(couponDiscount, this.valueBaseSunWithDiscout)

    this.valueTotalDiscount += this.valueTotalCupons

    const baseAfterCoupon = this.valueBaseSunWithDiscout - this.valueTotalCupons

    if (service && service.length > 0) {
      let runningBase = baseAfterCoupon

      this.valueBaseExtraServices = 0

      const orderedServices = [...service].sort(
        (a, b) =>
          Number(b.conditionType === EMoneyConditionType.FixedValue) -
          Number(a.conditionType === EMoneyConditionType.FixedValue),
      )

      for (const extra of orderedServices) {
        const plusValue = extra.getAddValue(runningBase)

        runningBase += plusValue

        this.valueBaseExtraServices += plusValue
      }
    }

    this.valuefinalWithoutAwards = baseAfterCoupon + this.valueBaseExtraServices

    if (awards && awards.length > 0) {
      const appliedAwards = ApplyAwardDiscounts({
        candidates: awards.map((award) => ({ source: award, award })),
        initialTotal: this.valuefinalWithoutAwards,
      })

      this.valueTotalAwards = appliedAwards.reduce((total, applied) => total + applied.discount, 0)
    }

    this.valuefinal = this.valuefinalWithoutAwards - this.valueTotalAwards
  }
}
